<template>
  <div class="page">
    <Waterfall :listData="works" @useGetData="getData()" v-if="!isShowNotice" />
    <div class="award-notice" v-html="notice" v-else>{{ notice }}</div>
    <!-- <WorksGroup @getGid="filterData" /> -->
    <!-- <div class="empty" v-if="total == 0">
      <i></i>
      <p>没有</p>
    </div> -->
  </div>
</template>

<script>
import Waterfall from "@/components/WaterfallAward";
export default {
  components: {
    Waterfall,
  },
  props: {
    worksGroup: {
      type: Array,
    },
  },
  data() {
    return {
      isShowNotice: false || this.$route.query.showNotice,
      notice: "",
      works: [],
      matchGroup: [],
      totalPage: 0,
      id: this.$route.params.id,
      // 是否到底部
      end: false,
      gid: "",
      page: 1,
      totalPages: 2,
      // totalPage: 0, // 总页数
      pagesize: 20, // 默认每页20条数据
      total: 0,
    };
  },
  methods: {
    getNotice() {
      this.tools.detail_cache({ id: this.id }, true).then((res) => {
        this.notice = res.notice_wap;
      });
    },
    filterWoks(gid) {
      // console.log(gid);
      if (this.gid != gid) {
        this.$router.push({ query: { group: gid } });
      }
      this.gid = gid;
      this.page = 1;
      this.end = false;
      this.works = [];
      // 重新筛选
      this.getData();
    },
    getList(res) {
      this.works = this.works.concat(res);
      if (this.page < this.totalPages) {
        this.page++;
      } else {
        this.end = true;
      }
    },
    getData() {
      if (this.end) {
        return false;
      }
      this.axios
        .post("/match/winworks?group=" + this.gid, {
          id: this.id,
          page: this.page,
          pagesize: this.pagesize,
        })
        .then((res) => {
          var data = res.data.data;
          if (this.page <= 1) {
            this.total = data.total;
            this.totalPages = data.totalPages;
          }
          this.getList(data.list);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    if (this.isShowNotice) {
      this.getNotice();
    }
  },
  mounted() {
    //this.cur = this.$route.query.index;
    this.gid = this.$route.query.group;
    if (this.gid == undefined) {
      this.gid = "";
    }
      var data = {url:window.location.href,id:this.id};
      this.tools.wx_share_init(data);
    // this.filterWoks(this.gid);
  },
};
</script>

<style lang="scss">
.award-notice {
  img {
    max-width: 100%;
  }
}
html{
  height: auto !important;
}
</style>
